import { render, staticRenderFns } from "./RequestRts.vue?vue&type=template&id=83d91e1a"
import script from "./RequestRts.vue?vue&type=script&lang=js"
export * from "./RequestRts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports